import React from "react";
import Dialog from "@mui/material/Dialog";

const ConfirmationModal = ({
  isOpen,
  setIsOpen,
  title,
  message,
  confirmLabel,
  onConfirm,
  cancelLabel,
  onCancel,
  isLoading = false,
  loadingMessage = "Processing...",
}) => {
  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <div className="p-6">
        <h2 className="text-lg font-semibold mb-4">{title}</h2>
        <p className="mb-6">{message}</p>
        <div className="flex justify-end space-x-4">
          <button
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded
                hover:bg-gray-300"
            onClick={() => {
              onCancel();
              handleClose();
            }}
          >
            {cancelLabel || "Cancel"}
          </button>
          <button
            className="px-4 py-2 bg-red-700 text-white rounded
                hover:bg-red-800"
            onClick={() => {
              onConfirm();
            }}
          >
            {confirmLabel || "Confirm"}
          </button>
        </div>
        {isLoading && (
          <div className="mt-4 text-center">
            <span className="loader"></span>
            <p>{loadingMessage}</p>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default ConfirmationModal;
